import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as multipleChoiceMultipleAnswerServices from '@iso/services/listening/multipleChoiceMultipleAnswer';

//#region CRUD
export function* getMultipleChoiceMultipleAnswer() {
	yield takeLatest(actions.GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(multipleChoiceMultipleAnswerServices.getMultipleChoiceMultipleAnswer, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.LISTENING_LOADING_FALSE,
			});
		}
	});
}

export function* getMultipleChoiceMultipleAnswerDetail() {
	yield takeLatest(actions.GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER_DETAIL, function* ({ payload, cbSuccess, cbError }) {
		const { id } = payload;
		try {
			var response = yield call(multipleChoiceMultipleAnswerServices.getMultipleChoiceMultipleAnswerDetail, id);
			if (response.data.success === true) {
				var data = response?.data?.data;
				yield put({
					type: actions.GET_MULTIPLE_CHOICE_MULTIPLE_ANSWER_DETAIL_SUCCESS,
					payload: { data },
				});
				cbSuccess(response?.data?.data);
			}
		} catch (e) {
			cbError(e?.response?.data);
			yield put({
				type: actions.LISTENING_LOADING_FALSE,
			});
		}
	});
}

export function* createQuesMultipleChoiceMultipleAnswer() {
	yield takeLatest(actions.CREATE_NEW_QUESTION_MULTIPLE_CHOICE_MULTIPLE_ANSWER, function* ({ payload, cbSuccess, cbError }) {
		const { body } = payload;
		try {
			var response = yield call(multipleChoiceMultipleAnswerServices.createQuesMultipleChoiceMultipleAnswer, body);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
			if (e.response && e.response.data)
				if (e.response.data.ErrorMessage === "ORDER_IN_SET_CANNOT_BE_DUPLICATED") {
					yield cbError('Trùng thứ tự');
				} else {
					yield cbError();
				}
		}
	});
}

export function* updateMultipleChoiceMultipleAnswerDetail() {
	yield takeLatest(actions.UPDATE_MULTIPLE_CHOICE_MULTIPLE_ANSWER_DETAIL, function* ({ payload, cbSuccess, cbError }) {
		const { model } = payload;

		try {
			var response = yield call(multipleChoiceMultipleAnswerServices.updateMultipleChoiceMultipleAnswerDetail, model);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
			if (e.response && e.response.data)
				if (e.response.data.ErrorMessage === "ORDER_IN_SET_CANNOT_BE_DUPLICATED") {
					yield cbError('Trùng thứ tự');

				} else {
					yield cbError(e.response.data.ErrorMessage);
				}
			yield cbError();
		}
	});
}

export function* deleteMultipleChoiceMultipleAnswer() {
	yield takeLatest(actions.DELETE_MULTIPLE_CHOICE_MULTIPLE_ANSWER, function* ({ payload, cbSuccess, cbError }) {
		const { id } = payload;
		try {
			var response = yield call(multipleChoiceMultipleAnswerServices.deleteMultipleChoiceMultipleAnswer, id);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
			else yield cbError();
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getMultipleChoiceMultipleAnswer),
		fork(getMultipleChoiceMultipleAnswerDetail),
		fork(createQuesMultipleChoiceMultipleAnswer),
		fork(updateMultipleChoiceMultipleAnswerDetail),
		fork(deleteMultipleChoiceMultipleAnswer),
	]);
}
